import React, {
    ReactElement,
} from "react";
import { Form } from "react-bootstrap";
import ExpandingSection from "../../../../components/expanding-section/ExpandingSection";
import WorkflowServiceApiSelector from "./ApiSelector";
import { Json } from "./base";

export default function WorkflowServiceArticles({ json, onChange, rootJson }: {
    rootJson: Json;
    json: Json;
    onChange: (current: Json) => void;
}): ReactElement {
    return (
        <ExpandingSection title="Articles">
            <Form.Group className="mb-3">
                <Form.Label className="fw-bolder">Start Api</Form.Label>
                <Form.Text className="d-block">
                    Start Api
                </Form.Text>
                <WorkflowServiceApiSelector
                    rootJson={rootJson}
                    json={json?.startApi as Json}
                    onChange={value => onChange({
                        ...json,
                        startApi: value,
                    })}

                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label className="fw-bolder">Get Page Api</Form.Label>
                <Form.Text className="d-block">
                    Start Api
                </Form.Text>
                <WorkflowServiceApiSelector
                    rootJson={rootJson}
                    json={json?.getPageApi as Json}
                    onChange={value => onChange({
                        ...json,
                        getPageApi: value,
                    })}

                />
            </Form.Group>

        </ExpandingSection>
    );
}
